var React = require('react');

function Dropdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","d":"M1.80176 1L9.34375 8.65092L16.8848 1","strokeWidth":"2","strokeLinecap":"round"}));
}

Dropdown.defaultProps = {"width":"18","height":"11","viewBox":"0 0 18 11","fill":"none"};

module.exports = Dropdown;

Dropdown.default = Dropdown;
